import React, { Fragment, useEffect } from 'react';

import { Button, Checkbox, Col, Divider, Form, Input, Row, Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { setIsSuccess, createPassword } from './redux/slice';

import Container from '../../components/container/Container';

import { PasswordRegex } from '../../utils/constraints';

const { Title, Text } = Typography;

const SetPassword = () => {
    const navigate = useNavigate();
    const { state } = useLocation();

    const [form] = Form.useForm();

    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);
    const onFinish = (values) => {
        dispatch(createPassword({ password: values.password, id: state?.id && state.id, token: state?.token && state?.token }));
    };

    useEffect(() => {
        if (auth.isSuccess) {
            form.resetFields();
            navigate('/user/welcome');
            dispatch(setIsSuccess(false));
        }
    }, [auth.isSuccess]);

    return (
        <Fragment>
            <Container className='vh-100' justify='center' align='center'>
                <Row justify={'center'} align={'middle'} className='vh-100'>
                    <Col xxl={6} xl={8} lg={12} md={16} sm={16} xs={24} className='bg-white padding-2 rounded-2'>
                        <Title level={4} type='success' className='paddingY-1'>Passwort einrichten</Title>
                        <Text>
                            Bitte erstelle ein sicheres Passwort nach den folgenden Kriterien.
                        </Text>
                        <Divider />
                        <Form
                            name='setpassword'
                            onFinish={onFinish}
                            layout='vertical'
                            requiredMark={false}
                            form={form}
                        >
                            <Form.Item
                                name='password'
                                label='Neues Passwort'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Passwort ist erforderlich!',
                                    },
                                    {
                                        pattern: new RegExp(PasswordRegex),
                                        message: 'Ungültiges Passwort!'
                                    }
                                ]}
                                hasFeedback
                            >
                                <Input.Password placeholder='Neues Passwort' />
                            </Form.Item>

                            <Form.Item
                                name='confirmPassword'
                                label='Passwort bestätigen'
                                dependencies={['password']}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: 'Bitte Passwort bestätigen!',
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Die Passwörter stimmen nicht überein!'));
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password placeholder='Passwort wiederholen' />
                            </Form.Item>
                            <Text type='secondary'>
                                Das Passwort muss mindestens eine Zahl, ein Sonderzeichen und einen Großbuchstaben enthalten.
                            </Text>
                            <Divider />
                            <Form.Item
                                name='acceptConditions'
                                valuePropName='checked'
                                rules={[
                                    {
                                        validator: (_, value) =>
                                            value ? Promise.resolve() : Promise.reject(new Error('Bitte stimme den Nutzungsbedingungen zu!')),
                                    },
                                ]}
                            >
                                <Checkbox>Ich stimme den Nutzungsbedingungen zu</Checkbox>
                            </Form.Item>

                            <Button type='primary' htmlType='submit' loading={auth?.loading}>
                                Passwort speichern
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default SetPassword;
